import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#A)",
		children: /* @__PURE__ */ _jsx("path", { d: "M9.333 16c-.144 0-.285-.047-.4-.133l-2.667-2c-.083-.062-.15-.143-.196-.235S6 13.437 6 13.333V9.587L1.323 4.325a2.6 2.6 0 0 1-.426-2.791A2.6 2.6 0 0 1 3.267 0h9.467a2.6 2.6 0 0 1 2.369 1.535 2.6 2.6 0 0 1-.427 2.79L10 9.587v5.747c0 .177-.07.346-.195.471S9.51 16 9.333 16zm-2-3l1.333 1V9.333c0-.163.06-.321.169-.443l4.845-5.451c.162-.183.267-.408.304-.649s.003-.488-.097-.71-.262-.411-.467-.544-.443-.203-.687-.203H3.267c-.244 0-.482.071-.687.204s-.367.321-.467.543-.134.469-.097.71.142.466.303.649l4.846 5.452c.108.122.168.28.168.443V13z" })
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "A",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgFilter;
